import * as Sebrae from '@sebrae/react-core';
import React, { createContext, useContext } from 'react';

import { useUfController } from '../../../hooks/controllers/uf-controller';
import { useModule } from '../../../hooks/module/module';

const cache = Sebrae.StorageUtil.inTemporaryStore();
const cacheKeySebrae = '@empretec:sebrae';

export const TableInterviewContext = createContext();

export const TableInterviewProvider = ({ children }) => {
  const { moduleSelected } = useModule();
  const { fetchData, data, loading, error } = Sebrae.usePagination(
    `v1/interviews/module/${moduleSelected?.id ?? 1}`,
  );
  const { getUfs } = useUfController();

  React.useEffect(() => {
    const elemento = [...document.querySelectorAll('small')].find(
      (el) => el.textContent.trim() === 'Filtros',
    );
    if (elemento) {
      elemento.style.display = 'none';
    }
  }, []);

  const handleFetchInterviewData = React.useCallback(async () => {
    try {
      const cachedUf = cache.getItem(cacheKeySebrae);

      const response = await getUfs();
      const foundUf = response.find((e) => e.sigla === cachedUf);

      const idsUf = foundUf ? [foundUf.id] : [];
      if (!cache.hasItem(cacheKeySebrae) || cachedUf === 'NA') {
        return fetchData();
      }

      const defaultFilter = {
        filter: {
          fieldOfResearch: '',
          sortField: 'interviewDate',
          filterType: '',
          filterCityName: '',
          originInterview: 'MANAGER',
          idsUf,
        },
        page: {
          size: 10,
          index: 0,
        },
        sort: { type: 'DESC' },
      };

      return fetchData(defaultFilter);
    } catch (error) {
      console.error('Erro ao buscar dados da entrevista:', error);
    }
  }, [fetchData, getUfs]);

  const clearAll = React.useCallback(() => {
    return fetchData({
      filter: {
        fieldOfResearch: '',
        sortField: 'interviewDate',
        filterType: '',
        filterCityName: '',
        originInterview: '',
        ufs: [],
        cities: [],
        emails: [],
        statusCompletingInterviews: [],
        statusInterviews: [],
      },
      page: {
        size: 10,
        index: 0,
      },
      sort: { type: 'DESC' },
    });
  }, [fetchData]);

  return (
    <TableInterviewContext.Provider
      value={{
        fetchData,
        data,
        loading,
        error,
        handleFetchInterviewData,
        clearAll,
      }}
    >
      {children}
    </TableInterviewContext.Provider>
  );
};

export const useTableInterview = () => {
  const context = useContext(TableInterviewContext);
  if (!context) {
    throw new Error(
      'useTableCandidate deve ser usado dentro de um TableCandidateProvider',
    );
  }
  return context;
};
